export enum VsResult {
  Win = 0,
  Loss = 1,
  Tie = 2,
}
